import { API, APIResponse } from 'Shared/services/apiInterface';

const CREATE_TICKET_ENDPOINT  = '/v1/ticket';
const GET_CATEGORIES_ENDPOINT = '/v1/categories';

/**
 * Creates a user submitted
 * support ticket on SalesForce side
 */
export const createTicket = (ticketData: TicketModel): Promise<APIResponse> => {
  return API({
    method : 'PUT',
    url    : process.env.REACT_APP_MCT_BASE_URL + CREATE_TICKET_ENDPOINT ,
    data   : JSON.stringify(ticketData),
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

/**
 * Gets categories from backend
 */
export const getCategories = (): Promise<APIResponse> => {
  return API({
    method : 'GET',
    url    : process.env.REACT_APP_MCT_BASE_URL + GET_CATEGORIES_ENDPOINT ,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export interface TicketModel {
  status        : string,
  origin        : string,
  subject       : string,
  description   : string,
  country       : string,
  devicePlatform: string,
  email         : string,
  category      : string,
  suppliedName  : string,
  surveyStatus  : string
}
